import apiClient from "../api/apiClient";

export const placeBids = async (endpoint, body) => {
  try {
    const token = localStorage.getItem("accessToken");   
    const registerId = localStorage.getItem("registerId");

    if (!token || !registerId) {
      console.error("No token found");
      return {
        status: false,
        authExpired: true,
        msg: "Session expired. Please login again.",
      };
    }

    const response = await apiClient.post(endpoint, body);

    return response.data;
  } catch (error) {
    console.error("API Error:", error?.response || error);

    if (error.response?.status === 401) {
      return {
        status: false,
        authExpired: true,
        msg: "Session expired. Please login again.",
      };
    }

    return {
      status: false,
      msg:
        error.response?.data?.msg ||
        "Network error. Please try again later.",
    };
  }
};
